import { render, staticRenderFns } from "./SaveProjectModal.vue?vue&type=template&id=07e44f61&scoped=true"
import script from "./SaveProjectModal.vue?vue&type=script&lang=js"
export * from "./SaveProjectModal.vue?vue&type=script&lang=js"
import style0 from "./SaveProjectModal.vue?vue&type=style&index=0&id=07e44f61&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e44f61",
  null
  
)

export default component.exports